// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import { createApp } from 'vue';
import router from './router';
import { store } from './store';
import App from "./App.vue";
import VueGoogleMaps from 'vue3-google-map'
import '@/assets/css/bootstrap.min.css'
import '@/assets/css/bootstrap.bundle.min.js'
import '@/assets/fontawesome/css/fontawesome.min.css'
import '@/assets/fontawesome/css/all.min.css'
import '@/assets/css/dropzone/dropzone.min.css'
import '@/assets/css/style.css'
import '@/assets/css/auth-style.css'
import 'slick-carousel/slick/slick.css';
import '@/assets/css/jquery-bootstrap-datepicker.css' //jquery-ui/jquery-ui.min.css';
import '@/assets/css/jquery-ui/jquery-ui.min.js'
import '@/assets/css/dropzone/dropzone.min.js';
import '@/assets/css/fancybox/jquery.fancybox.min.css';
import '@/assets/css/fancybox/jquery.fancybox.min.js';
import '@/assets/css/slick.js';
import '@/assets/utils/script.js';
/** Components */
import LayoutHeader from '@/components/Layout/Header'
import LayoutFooter from '@/components/Layout/Footer'
/** Components */
import jquery from 'jquery';
import moment from 'moment'
window.$ = window.jQuery = jquery;

const app = createApp(App)
app.config.globalProperties.$ = jquery;
app.component('layout-header', LayoutHeader)
app.component('layout-footer', LayoutFooter)
app.config.productionTip = false
app.use(VueGoogleMaps, {
    load: {
        key: 'AIzaSyD6adZVdzTvBpE2yBRK8cDfsss8QXChK0I',
        libraries: 'places,marker',
    },
})
app.use(store)
.use(router)
.mount('#app');